module.exports = __webpack_public_path__ + "static/media/beautify_btn_white.92dbee57.png";